const MODAL_ID = "modal-discontinued-colors"
const DISMISSED = "dismissed"

function storageKey() {
  return document.getElementById(MODAL_ID)?.dataset.storageKey
}

function isDismissed(key) {
  try {
    return localStorage.getItem(key) === DISMISSED
  } catch {
    return false
  }
}

function initDiscontinuedColorsModal() {
  const key = storageKey()

  if (key && !isDismissed(key)) {
    window.showModal(MODAL_ID)
  }
}

function dismissDiscontinuedColorsModal() {
  try {
    localStorage.setItem(storageKey(), DISMISSED)
  } catch {}

  window.closeModal(MODAL_ID)
}

window.dismissDiscontinuedColorsModal = dismissDiscontinuedColorsModal

document.addEventListener("DOMContentLoaded", initDiscontinuedColorsModal)
